import React, { useState, useEffect } from "react"
import PropTypes from "prop-types"
import { Space } from "antd"
import Picker from "../components/picker"

/*
  *Filter* takes in a set of options which define:
  - which categories are available
  - how those categories are linked (e.g. subcategories)
  Returns:
  - an object of {categoryId: selectedFilterValue}

  the actual filtering is left to the parent
*/
const Filter = ({categories, returnFilters}) => {
  
  // returns the index if the category is found, otherwise false
  const findCategoryIndex = (categoryID, categories) => {
    for(const i in categories) {
      if(categories[i].id === categoryID) {
        return i
      }
    }
    return false
  }

  /*
  const updateCategories = (selection, categoryID, categories) => {
    for(const i in categories) {
      if(selection && categories[i].id === categoryID) {
        categories[i].selected = selection
      }
    }
    return categories
  }
  */

  return(
    <Space direction="horizontal" size="large">
      {
        categories.map((category, catIndex) => {
          return (
          <Picker
            key={category.id}
            selected={category.selected ? category.selected : category.options[0]}
            options={category.options
            // this filter allows for subcategories e.g. only show a subset off neighborhoods when a city is selected
            .filter(option => {
              if(option.parent) {
                const parentIndex = findCategoryIndex(option.parent.id, categories)
                if(parentIndex && categories[parentIndex].selected) {
                  const parentValue = categories[parentIndex].selected.value // the selected parent value
                  if(parentValue && parentValue === option.parent.value) {
                    return true
                  }
                  else {
                    return false
                  }
                }
              }
              return true
            })
          }
            onSelect={(value) => {
              const newCategories = [...categories]
              newCategories[catIndex].selected = value
              if(category.child) {
                for(const i in newCategories) {
                  const f = newCategories[i]
                  if(f.id === category.child) {
                    newCategories[i].selected = {name:f.name, value:null, id:"default"}
                  }
                }
              }
              returnFilters(newCategories)
            }}
          />
        )})
      }
    </Space>
  )
}

const FilterOptionPropType = PropTypes.shape({
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.string,
  parent: PropTypes.shape({
    id: PropTypes.string,
    value: PropTypes.string
  }),
})

Filter.propTypes = {
  categories: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    child: PropTypes.string,
    selected: FilterOptionPropType,
    options: PropTypes.arrayOf(FilterOptionPropType).isRequired,
  })).isRequired,
  returnFilters: PropTypes.func.isRequired
}

export default Filter